<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-3" >
                <template #default>   <m-chat-widget-3 v-bind='{...{"enableAnimation":false},...{}}' :style='""' class="" ></m-chat-widget-3><m-chat-archive-1 v-bind='{...{},...{}}' :style='""' class="mt-5" ></m-chat-archive-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mChatWidget3 from '@moeinmdn/miw-alpha-components/src/package/Chat/Widget/ChatWidget3'; import mChatArchive1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Archive/ChatArchive1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mChatWidget3,mChatArchive1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
